import { InjectionToken } from '@angular/core';
import { Config } from '@modeso/aumico-lib-core-fe';

export interface AumicoSettingsConfig extends Config {
    /**
     * With an ending forward slash
     */
    apiGateway: string;
    /**
     * Without slashes
     */
    serviceId: string;

    /**
     * May have values like:
     * headers: {
     *   'Content-Type': 'application/json',
     *   'content-language': 'de-ch'
     *   }
     */
    httpOptions: {
        headers: {
            [key: string]: string;
        };
    };

    // if true, the service is used in the prototyping framework
    // so that all calls respond with 200 success and predefined data, if not otherwise defined
    prototype?: boolean;
}

export const AumicoSettingsConfigService = new InjectionToken<AumicoSettingsConfig>('SETTINGS_CONFIG');
